"use strict";

var _slicedToArray = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var context_1 = __importDefault(require("./context"));

var property_1 = __importDefault(require("./property"));

var Guest =
/*#__PURE__*/
function (_context_1$default) {
  _inherits(Guest, _context_1$default);

  function Guest(id) {
    var _this;

    var property = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new property_1.default();

    _classCallCheck(this, Guest);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Guest).call(this, "g", id, property));
    _this.type = "g";
    _this.property = property;
    return _this;
  }

  _createClass(Guest, null, [{
    key: "fromString",
    value: function fromString(context) {
      var _context$split = context.split("/g/"),
          _context$split2 = _slicedToArray(_context$split, 2),
          remaining = _context$split2[0],
          gid = _context$split2[1];

      return new Guest(gid, property_1.default.fromString(remaining));
    }
  }, {
    key: "test",
    value: function test(context) {
      var _context$split3 = context.split("/g/"),
          _context$split4 = _slicedToArray(_context$split3, 2),
          remaining = _context$split4[0],
          gid = _context$split4[1];

      return typeof gid === "string" && gid.length > 0 && property_1.default.test(remaining);
    }
  }, {
    key: Symbol.toPrimitive,
    value: function value(hint) {
      if (hint === "string" || hint === "default") {
        return "".concat(property_1.default, "/g/+\"");
      }

      throw new TypeError("Invalid primitive conversion");
    }
  }]);

  return Guest;
}(context_1.default);

exports.default = Guest;